import React, { Component } from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import media from 'src/styles/media';

import DownArrow from 'src/components/DownArrow';

export default class Header extends Component {
  render() {
    const { image, smallText, largeText, darken } = this.props;
    return (
      <Root image={image} darken={darken}>
        <Circle>
          <p>{smallText}</p>
          <h1>{largeText}</h1>
        </Circle>
        <DownArrow />
      </Root>
    );
  }
}

Header.propTypes = {
  image: PropTypes.string,
  smallText: PropTypes.string,
  largeText: PropTypes.string,
  darken: PropTypes.bool,
};

const Root = styled.header`
  width: 100%;
  height: 100vh;
  background-image: ${props =>
    props.darken
      ? `linear-gradient(rgba(0, 0, 0, 0.2), rgba(0, 0, 0, 0.2)), url(${
          props.image
        })`
      : `url(${props.image})`};
  background-blend-mode: multiply;
  background-position: 30% center;
  background-size: cover;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
`;

const Circle = styled.div`
  width: 80vw;
  height: 80vw;
  border: 1px solid white;
  border-radius: 50%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: white;
  position: relative;
  text-transform: uppercase;
  text-align: center;
  font-family: ${({ theme }) => theme.fontHeader};
  @media (min-width: ${media.smup}) {
    width: 55vh;
    height: 55vh;
  }
  h1 {
    color: white;
    font-family: ${({ theme }) => theme.fontMain};
    font-size: 32px;
    letter-spacing: 1.37px;
  }
  &::after {
    content: '';
    position: absolute;
    left: 50%;
    top: 50%;
    width: 120vw;
    height: 120vw;
    transform: translate(-50%, -50%);
    border: 1px solid white;
    border-radius: 50%;
    @media (min-width: ${media.smup}) {
      width: 75vh;
      height: 75vh;
    }
  }
`;



// WEBPACK FOOTER //
// ./src/components/Header.js